import firebase from '../firebase'
import Store from '../store/Store'
import FirebaseHelpers from './FirebaseHelpers'
import DataHelpers from './DataHelpers'
import NiceData from '../data/NiceData'

var db = firebase.database()

export default class {

//can pass a tenant key or the string 'global' to access system templates...
  
static fetchTemplate(tenantKey, templateName) {
    return new Promise( (resolve, reject) => {
        let ref
        if(tenantKey == 'global')
            ref = DataHelpers.getRootRef().child('app').child('templates').orderByChild('name').equalTo(templateName)
        else
            ref = DataHelpers.getTenantRef(tenantKey).child('templates').orderByChild('name').equalTo(templateName)

        ref.once('value', function(snap) {
            let templates = NiceData.arrayFromSnapshot(snap)
            let template
            if(templates.length < 1)
                template = null
            else if(templates.length > 1) {
                template = templates[0]
                console.log('fetchTemplate > duplicate templates found, but continuing...', templates)
            } else
                template = templates[0]

            resolve(template)
        })  
    })       
}

} // end class


// WEBPACK FOOTER //
// ./src/helpers/TemplateHelpers.js